import {
  BaseURL,
  CashbackLevel,
  Currency,
  CurrencyCode,
  CurrencySign, FeatureFlag,
  FeatureFlags,
  Region,
  Registration,
  UserProfileFormType,
} from 'app/api/services/site-configs/types';
import type { ReduxState } from 'app/redux/types';

import type { SiteConfigState } from './slice';
import type { PresetItem } from './transform-preset-item';

export const baseUrl = (state: ReduxState): BaseURL => (
  state.siteConfigs?.baseUrl || ''
);

export const siteCurrency = (state: ReduxState): Currency | undefined => (
  state.siteConfigs?.currency
);

export const currencySymbol = (state: ReduxState): CurrencySign => (
  siteCurrency(state)?.symbol || ''
);

export const siteCurrencyAbbr = (state: ReduxState): CurrencyCode => (
  siteCurrency(state)?.abbr || 'RUB'
);

export const registration = (state: ReduxState): Registration | undefined => (
  state.siteConfigs?.registration
);

// domain zone
export const getUserProfileFormType = (state: ReduxState): UserProfileFormType | undefined => (
  state.siteConfigs?.userProfile?.formType
);

export const getBetPresets = (state: ReduxState): PresetItem[] | undefined => (
  state.siteConfigs?.betPresets
);

export const getDefaultCountry = (state: ReduxState): string | undefined => (
  state.siteConfigs?.defaultCountry
);

export const getDefaultRegion = (state: ReduxState): string | undefined => (
  state.siteConfigs?.defaultRegion
);

export const getRegions = (state: ReduxState): Region[] | undefined => (
  state.siteConfigs?.regions
);

export const selectCashbackLevels = (state: ReduxState): CashbackLevel[] | undefined => (
  state.siteConfigs?.cashbackLevels
);

export const isMultiDomain = (state: ReduxState): boolean => (
  state.siteConfigs?.multiDomain ?? false
);

export const isUsernameHidden = (state: ReduxState): boolean => (
  state.siteConfigs?.isUsernameHidden ?? true
);

export const promptOnStakeCashout = (state: ReduxState): boolean => (
  state.siteConfigs?.promptOnStakeCashout ?? true
);

export const promptOnStakeCashoutIncrease = (state: ReduxState): boolean => (
  state.siteConfigs?.promptOnStakeCashoutIncrease ?? true
);

export const promptOnStakeCashoutDecrease = (state: ReduxState): boolean => (
  state.siteConfigs?.promptOnStakeCashoutDecrease ?? true
);

export const getFeatureFlags = (state: ReduxState): FeatureFlags[] => (
  state.siteConfigs?.featureFlags || []
);

export const isFFPrematchWS = (state: ReduxState): boolean => (
  getFeatureFlags(state).includes(FeatureFlag.PREMATCH_WS)
);

export const getPreMatchFilters = (state: ReduxState): FeatureFlags[] => (
  state.siteConfigs?.preMatchFilters || []
);

export default (state: ReduxState): SiteConfigState => state.siteConfigs;
